import css from 'styled-jsx/css';

const styles = css`:global(.card){width:420px}:global(.forgot-button){width:200px !important;margin:auto;margin-top:16px}`;

export default styles;